/** Valores base al activar modo padre. */
export function parentScoreReset(): Record<string, unknown> {
  return { score: null, evidenceRequired: false };
}

/** Limpia evidencias del formulario padre. */
export function parentEvidenceReset(): Record<string, unknown> {
  return { evidenceTrue: null, evidenceFalse: null, evidenceType: null };
}

/** Limpia metas y fechas del formulario padre. */
export function parentGoalReset(): Record<string, unknown> {
  return { goalType: 'general', goalValue: null, deadline: null, months: null };
}

/** Indica si hay subpreguntas. */
export function hasSubitems(count: number): boolean {
  return count > 0;
}
